import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';

class PressesAndShears extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData: '',
            updatingFields: false,
        };
    }

    sigCanvas = {}

    handleSign = () => {
        this.setState({signatureData: this.sigCanvas.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature = this.state.signatureData
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={16} alignItems="center">
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="producer"
                                label='Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="type"
                                label='Typ'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="construction_year"
                                label='Baujahr:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="address"
                                label='Adresse'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.address}
                            />
                        </Grid>
                        <Grid item xs={4}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="security_officer"
                                label='Sicherheitsbeauftragter:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.security_officer}
                            />
                        </Grid>
                        <Grid item xs={8}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="security_officer_contact"
                                label='Telefon/E-Mail:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.security_officer_contact}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Bauart:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_1"
                                        label='mechanische Presse'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_1}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_2"
                                        label='hydraulische Presse'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_3"
                                        label='Spindelpresse'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="type_4"
                                        label='sonstige'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type_4}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Prüfgrundlage:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_1"
                                        label='VBG 7n5.1'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_1}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_2"
                                        label='FVBG 7n5.2'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_3"
                                        label='VBG 7n5.3'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_4"
                                        label='BetrSichV'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_4}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>

                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_5"
                                        label='EN 692'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_5}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_6"
                                        label='EN 693'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_6}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="test_basis_7"
                                        label='EN 289'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.test_basis_7}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="safe_tool"
                                        label='Sicheres Werkzeug'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.safe_tool}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="fixed_cover"
                                        label='Feste Verdeckung'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.fixed_cover}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="movable_cover"
                                        label='Bewegliche Verdeckung'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.movable_cover}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="electro_sensitive"
                                        label='Berührungslos wirkende Schutzeinrichtung (BWS)'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.electro_sensitive}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="two_hand_control"
                                        label='Zweihandsteuerung (ZHS)'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.two_hand_control}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="deflecting_guard"
                                        label='Abweisende Schutzeinrichtung'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.deflecting_guard}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="multiple_jobs"
                                        label='Mehrere ArbeitsplÃ¤tze'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.multiple_jobs}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={3} xs={12}>
                                    <FormCheck
                                        name="setup_1"
                                        label='Einrichten'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.setup_1}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="rated_voltage"
                                label='Nennspannung:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rated_voltage}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="rated_current"
                                label='Nennstrom:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rated_current}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="inventory_number"
                                label='Maschinen/Inventarnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inventory_number}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="rated_power"
                                label='Nennleistung:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.rated_power}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="nominal_pressure"
                                label='Nenndruck:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.nominal_pressure}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="date_of_the_test"
                                label='Datum der Prüfung:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.date_of_the_test}
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Table width="90% !important">
                    <TableHead>
                        <TableRow>
                            <TableCell width="40%">
                                &nbsp;
                            </TableCell>
                            <TableCell width="10%">
                                Erfüllt
                            </TableCell>
                            <TableCell width="10%">
                                Nicht erfüllt
                            </TableCell>
                            <TableCell width="10%">
                                Nicht zutreffend
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        1. ZHS (ZH 1/456, EN 574)
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Unbeabsichtigte Betätigung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Unbeabsichtigte Betätigung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Gleichzeitigkeit
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Aufhebung des Steuerbefehls bei Freigabe eines Steuerteils
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fehlersicherheit
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitsabstand
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Vollständige Verdeckung der Gefahrstellen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_1_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_1_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_1_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_1_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_1_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_1_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        2. Bewegliche Verdeckung (EN 294, EN 953)
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Vollständige Verdeckung der Gefahrstellen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_2_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_2_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_2_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_2_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_2_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_2_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fehlersicherheit
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_2_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_2_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_2_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_2_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_2_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_2_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        3. BWS (ZH 1/281, EN 999)
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Testung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fehlersicherheit
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kontrollleuchten für Schaltzustand
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Freigabe der Bewegung nach Verlassen des Schutzfeldes und Betätigung der Befehlseinrichtung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Blockieren bei Außerbetriebsetzen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Empfindlichkeitseinstellung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fremdeinflüsse
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitsabstand
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_3_h_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_3_h_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_3_h_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_3_h_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_3_h_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_3_h_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        4. Umstelleinrichtung
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Korrekte Einstellung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_4_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_4_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_4_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_4_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_4_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_4_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zwangsläufige Einstellung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_4_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_b_4_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_4_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_4_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_4_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_4_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Deutliche Erkennbarkeit
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_4_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_4_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_4_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_4_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_4_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_4_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Absicherung gegen unbeabsichtigtes Betätigen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_4_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_4_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_4_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_4_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_4_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_4_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kein Steuerbefeh
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_4_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_4_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_4_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_4_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_4_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_4_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        5. Ausschalteinrichtung
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Abschaltung Steuerung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Freigabe nach Entriegelung und Betätigung der Befehlseinrichtung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Leicht erreichbar
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kein Abschalten des Antriebs
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherung gegen Drucküberschreitung / Überlast
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Nachlaufüberwachung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Einrichtung gegen Absinken des Stössels - Tischtiefe > 800 mm
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Tischtiefe > 500 mm
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_h_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_h_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_h_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_h_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_h_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_h_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Einrichtung vorhanden
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_i_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_i_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_i_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_i_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_i_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_i_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Erkennung der Verriegelung in der Steuerung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_j_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_j_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_j_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_j_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_j_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_j_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Steuerung fehlersicher
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_k_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_k_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_k_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_k_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_k_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_k_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Betriebsanweisung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_l_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_l_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_l_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_l_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_l_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_l_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Pressenkontrollbuch
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_m_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_m_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_m_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_m_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_m_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_m_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Prüfhinweise des Herstellers - Betriebsanleitung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_5_n_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_5_n_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_5_n_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_5_n_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_5_n_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_5_n_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        6. Prüfung der Steuerung – ZH 1/457 – EN 954
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Betriebsbedingungen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fremdeinflüsse
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Selbstüberwachung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Umstelleinrichtungen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Einzelhubsicherung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Wiederanlaufsperre
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherung gegen Umgehen der Handschutzeinrichtung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_h_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_h_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_h_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_h_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_h_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_h_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Abschalten der Energie
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_i_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_i_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_i_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_i_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_i_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_i_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Drehrichtungsänderung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_j_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_j_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_j_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_j_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_j_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_j_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Nachlaufüberwachung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_k_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_k_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_k_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_k_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_k_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_k_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Einrichtbetrieb
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_l_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_l_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_l_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_l_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_l_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_l_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Pressensicherheitsventil
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_m_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_m_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_m_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_m_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_m_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_m_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verhinderung des Stösselabfalls - Keine Schneidring- und Klemmverschraubungen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_n_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_n_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_n_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_n_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_n_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_n_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Überlastschutz - Druckbegrenzungsventil zugänglich, verblombt
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_o_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_o_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_o_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_o_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_o_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_o_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Filterung des hydraulischen Mediums
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_p_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_p_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_p_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_p_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_p_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_p_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Filterung des hydraulischen Mediums
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_6_q_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_6_q_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_6_q_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_6_q_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_6_q_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_6_q_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        7. Berührungslos wirkende Schutzeinrichtung (BWS) – ZH 1/281, EN 999
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Funktion
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Empfindlichkeitseinstellung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Leuchtmelder
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Außerbetriebsetzen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Betriebsbedingungen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fremdeinflüsse
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Testung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_h_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_h_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_h_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_h_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_h_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_h_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Selbstüberwachung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_i_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_i_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_i_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_i_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_i_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_i_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitsabstand - s=1,6 m/s x t1, s=2,0 m/s x t1 - s100 mm
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_j_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_j_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_j_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_j_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_j_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_j_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Schutzeinrichtung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_k_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_k_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_k_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_k_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_k_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_k_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Schutz und Steuereinrichtung - Tischhöhe > 750 mm - Zusätzliche Sicherung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_l_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_l_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_l_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_l_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_l_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_l_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Unter-, Über-, Umgreifen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_m_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_m_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_m_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_m_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_m_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_m_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Aufenthalt zwischen Schutzfeld und Gefahrstelle
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_n_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_n_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_n_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_n_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_n_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_n_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Einwandfreie Funktion
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_o_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_o_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_o_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_o_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_o_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_o_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zustand der Bauteile
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_p_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_p_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_p_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_p_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_p_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_p_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zusammenwirken mit der Steuerung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_q_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_q_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_q_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_q_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_q_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_q_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Ordnungsgemäßer Aufbau
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_7_r_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_7_r_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_7_r_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_7_r_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_7_r_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_7_r_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        8. Zweihandsteuerung (ZHS) – ZH 1/456, EN 574
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Funktion
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Gleichzeitigkeit
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Gestaltung / Anordnung der Schaltorgane
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Betriebsbedingungen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fremdeinflüsse
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Selbstüberwachung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherheitsabstand - s=1,6 m7s x t1 - verstellbar - absich
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_h_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_h_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_h_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_h_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_h_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_h_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Einwandfreie Funktion
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_i_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_i_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_i_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_i_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_i_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_i_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zustand der Bauteile
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_j_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_j_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_j_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_j_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_j_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_j_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zusammenwirken mit der Steuerung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_8_k_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_8_k_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_8_k_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_8_k_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_8_k_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_8_k_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        9. Hydraulikschlauchleitungen – EN 982
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sichtprüfung - keine Schneidring-, Klemmringverbindungen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_b_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_b_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_b_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_b_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_b_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_b_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kennzeichnung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_c_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_c_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_c_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_c_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_c_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_c_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Eignung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_d_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_d_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_d_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_d_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_d_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_d_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verwendungsdauer 6 Jahre
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_e_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_e_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_e_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_e_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_e_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_e_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Beschädigungen • Schmierstellen, Risse, Schnitte
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_f_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_f_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_f_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_f_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_f_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_f_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Versprödung
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_g_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_g_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_g_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_g_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_g_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_g_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verformung • Blasen, Quetschstellen, Knickstellen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_h_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_h_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_h_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_h_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_h_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_h_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Undichte Stellen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_i_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_i_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_i_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_i_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_i_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_i_not_applicable}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Armaturen
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_1_content_9_j_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_1_content_9_j_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_2_content_9_j_not_okay"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_2_content_9_j_not_okay}
                                />
                            </TableCell>
                            <TableCell>
                                <FormCheck
                                    name="check_3_content_9_j_not_applicable"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.check_3_content_9_j_not_applicable}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={6}>
                                <Grid item xs={10}>
                                    <FormField
                                        type="text"
                                        name="notations"
                                        label='Bemerkungen:'
                                        multiline
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.notations}
                                    />
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <Grid item xs={12}>
                    <Grid container xs={12} spacing={8} justify="center" alignItems="center">
                        <Grid item xs={3}>Prüfplakette erteilt:</Grid>
                        <Grid item xs={9}>
                            <FormCheck
                                name="inspection_tag"
                                label='ja'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.inspection_tag}
                                labelPlacement="start"
                            />
                        </Grid>
                        <Grid item xs={3}>&nbsp;</Grid>
                        <Grid item xs={9}>
                            <FormCheck
                                name="no_inspection_tag"
                                label='nein'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.no_inspection_tag}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                        <Grid item xs={3}>&nbsp;</Grid>
                        <Grid item xs={6} style={{ border: '1px solid black' }}>
                            <SignatureCanvas
                                penColor='black'
                                canvasProps={{width: 600, height: 200}}
                                ref={(ref) => { this.sigCanvas = ref }}
                                onEnd={this.handleSign}
                            />
                        </Grid>
                        <Grid item xs={3}>&nbsp;</Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                        <Grid item xs={3}>&nbsp;</Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            Unterschrift
                        </Grid>
                        <Grid item xs={3}>&nbsp;</Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
});

export default withStyles(styles)(PressesAndShears)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/PressesAndShears.js